import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em",
  focusable: "false",
  role: "img",
  "aria-label": "chevron right",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  class: "bi-chevron-right b-icon bi",
  "data-v-41be6633": ""
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-v-41be6633": "" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}